const STORAGE_KEY = 'data_titipan';
const DELETED_IDS_KEY = 'data_titipan_deleted_ids';

const readDeletedIds = () => {
  try {
    const ids = JSON.parse(localStorage.getItem(DELETED_IDS_KEY) || '[]');
    return Array.isArray(ids) ? ids.map(String) : [];
  } catch {
    return [];
  }
};

const sanitizeValue = (value, key = '') => {
  if (Array.isArray(value)) {
    return value.map((item) => sanitizeValue(item));
  }

  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([childKey, childValue]) => [
        childKey,
        sanitizeValue(childValue, childKey),
      ])
    );
  }

  // Foto hasil FileReader dapat berukuran beberapa MB dan tidak diperlukan
  // untuk kartu riwayat. URL foto dari server tetap disimpan.
  if (
    typeof value === 'string' &&
    /^(photo|foto|image|gambar)$/i.test(key) &&
    value.startsWith('data:')
  ) {
    return null;
  }

  return value;
};

export const sanitizeHandoversForStorage = (data) =>
  sanitizeValue(Array.isArray(data) ? data : []);

export const readHandovers = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(stored) ? stored : [];
  } catch {
    return [];
  }
};

export const writeHandovers = (data) => {
  const deletedIds = new Set(readDeletedIds());
  const sanitized = sanitizeHandoversForStorage(data).filter(
    (item) => !deletedIds.has(String(item.id))
  );

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(sanitized));
    return sanitized;
  } catch (error) {
    // Jangan biarkan keterbatasan storage merusak alur penyimpanan ke server.
    console.warn('Cache handover tidak dapat disimpan ke localStorage:', error);
    return sanitized;
  }
};

export const deleteHandoversFromCache = (ids) => {
  const idsToDelete = new Set((Array.isArray(ids) ? ids : []).map(String));
  const deletedIds = new Set([...readDeletedIds(), ...idsToDelete]);

  try {
    localStorage.setItem(DELETED_IDS_KEY, JSON.stringify([...deletedIds]));
  } catch (error) {
    console.warn('Daftar handover terhapus tidak dapat disimpan:', error);
  }

  return writeHandovers(
    readHandovers().filter((item) => !idsToDelete.has(String(item.id)))
  );
};
